import { Icon } from "./Icon.tsx";

/**
 * A scatter/trend glyph, distinct from SummaryIcon.tsx's bar chart. The
 * trend line is solid, not dashed — a dashed line at this size anti-aliases
 * into a speckled mess.
 */
export function StatisticsIcon() {
  return (
    <Icon>
      <path d="M4 19h16" />
      <path d="M4 15 9 9l4 3 6-7" />
      <circle cx="9" cy="9" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="13" cy="12" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="19" cy="5" r="1.3" fill="currentColor" stroke="none" />
    </Icon>
  );
}
